import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/Tooltip';
import { Crm } from '@/services/CrmService';

interface BehaviorTagsProps {
  crm: Pick<Crm, 'audienceUser'>;
}

export function BehaviorTags({ crm }: BehaviorTagsProps) {
  return (
    <ul className="flex flex-wrap gap-1">
      {crm?.audienceUser?.slice(0, 2).map((audienceUser) => (
        <li key={audienceUser.audienceId}>
          <span className="rounded-full bg-gray-100 px-[10px] py-1 text-xs text-muted-foreground">
            {audienceUser.audience.name}
          </span>
        </li>
      ))}

      {(crm?.audienceUser?.length ?? 0) > 3 && (
        <li>
          <TooltipProvider>
            <Tooltip>
              <TooltipTrigger asChild>
                <button className="rounded-full bg-gray-100 px-[10px] py-1 text-xs text-muted-foreground">
                  ...
                </button>
              </TooltipTrigger>

              <TooltipContent className="bg-gray-900 p-4">
                <ul className="flex max-w-[600px] flex-wrap gap-4">
                  {crm?.audienceUser?.map((audienceUser) => (
                    <li key={audienceUser.audienceId}>
                      <span className="rounded-full bg-gray-100 px-[10px] py-1 text-xs text-muted-foreground">
                        {audienceUser.audience.name}
                      </span>
                    </li>
                  ))}
                </ul>
              </TooltipContent>
            </Tooltip>
          </TooltipProvider>
        </li>
      )}
    </ul>
  );
}
